<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('document')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATE_DOCUMENT' | translate) : ('TR_UPDATE_DOCUMENT' | translate) }}</h5>
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="wrap-flex form-outline">
        <div *ngIf="documentcategory_view" ngbDropdown>
          <div class="flex flex-column">
            <label>{{ ('TR_DOCUMENT_TYPE' | translate) + mainService.asterisk }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-primary" [class.error-border]="isInvalidSubmit && !form.value.documentCategoryId">
              {{ selectedDocumentCategoryName ? selectedDocumentCategoryName : ('TR_DOCUMENT_TYPE' | translate) + mainService.asterisk }}
            </button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of documentCategories" (click)="setSelectedDocumentCategory(item.id, item.name)">
              {{ item.name }}
            </button>
          </div>
        </div>
        <div *ngIf="!selectedFile" ngbDropdown>
          <div class="flex flex-column">
            <label>{{ 'TR_TEMPLATEE' | translate }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-primary">{{ selectedTemplateName ? selectedTemplateName : 'TR_TEMPLATEE' | translate }}</button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of templates" (click)="setSelectedTemplate(item)">
              {{ item.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2 mb-3 upload-block form-outline">
        <button type="button" class="mb-2 mr-2 btn-transition btn btn-warning upload-btn" (click)="file.click()">
          <i class="pe-7s-plus"></i>
          <p>{{ 'TR_UPLOAD_FILE' | translate }}</p>
        </button>
        <input #file hidden type="file" name="upload-file" (change)="handleFileInput($event.target.files)" />
        <div class="flex flex-column ml-2">
          <div class="webinar-image" *ngIf="fileName">{{ fileName }}</div>
          <div *ngIf="!fileName && filePath">{{ filePath }}</div>
          <button *ngIf="selectedFile" type="button" class="btn-transition btn btn-outline-dark" (click)="removeFile()">
            {{ 'TR_REMOVE' | translate }}
          </button>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="name">{{ ('TR_NAME' | translate) + mainService.asterisk }}</label>
            <input
              name="name"
              [placeholder]="('TR_NAME' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.name"
              autocomplete="off"
              formControlName="name"
            />
            <p class="warning-message">{{ 'TR_DOCUMENT_NAME_WARNING_MSG' | translate }}</p>
            <p *ngIf="form.controls['name'].hasError('pattern')" class="error">{{ 'TR_USERNAME_WARNING_MSG' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="description">{{ 'TR_DESCRIPTION_OR_NUMBER' | translate }}</label>
            <input
              name="description"
              [placeholder]="'TR_DESCRIPTION_OR_NUMBER' | translate"
              type="text"
              class="form-control"
              autocomplete="off"
              formControlName="description"
            />
            <p class="warning-message">{{ 'TR_DESCRIPTION_WARNING_MSG' | translate }}</p>
          </div>
        </div>
      </div>
      <ckeditor *ngIf="openRTE" [class.closed-form]="!closePopUp" [class.opened-form]="!selectedTemplateId" class="text" formControlName="data"></ckeditor>
      <div *ngIf="openTemplate" class="initial-pop-op" [class.template-pop-up]="selectedTemplateId" >
        <app-template-document-form
          (templateDataEmiter)="getTemplateData($event)"
          (closeEmit)="closeTemplate()"
          [templateData]="selectedTemplateData"
          [documentBodyData]="documentBodyData"
        ></app-template-document-form>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>